module.exports = require("react-dom/server");


/*****************
 ** WEBPACK FOOTER
 ** external "react-dom/server"
 ** module id = 8
 ** module chunks = 0
 **/